import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Intercept the browser / OS back button (history pop) on these routes so
 * `GameStatus.postMessage` can run in the native WebView when present; optional
 * chaining is a no-op in a normal desktop browser. Re-pushes history so users
 * do not land on a stale route (OTP/session issues).
 */
export function useMobileAppBrowserBackGuard() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    const pushGuard = () => {
      try {
        window.history.pushState({ totMobileAppBackGuard: true }, '', path);
      } catch {
        /* ignore */
      }
    };

    pushGuard();

    const onPopState = () => {
      window.GameStatus?.postMessage?.('navigate_back');
      pushGuard();
    };

    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [location.pathname, location.search, location.hash]);
}
